import moment from 'moment';
export const fuFoto = vNroDocumento => {
    const randomNumber = Math.random();
    return `https://academico.khipu.edu.pe/public/images/persona/${vNroDocumento}.jpg?v=${randomNumber}`;
}
export const fuMesMensualidad = vIdMes => {
    let arr = ['MATRICULA','ENERO','FEBRERO','MARZO','ABRIL','MAYO','JUNIO','JULIO','AGOSTO','SEPTIEMBRE','OCTUBRE','NOVIEMBRE','DICIEMBRE']
    return arr[vIdMes]
}
export const fuMesNombre = vIdMes => {
    let arr = ['','ENERO','FEBRERO','MARZO','ABRIL','MAYO','JUNIO','JULIO','AGOSTO','SEPTIEMBRE','OCTUBRE','NOVIEMBRE','DICIEMBRE']
    return arr[vIdMes]
}
export const fuMesNombreFecha = vFecha => {
    return fuMesNombre(parseInt(moment(vFecha).format("MM")));
}
export const fuMesNombreShort = vIdMes => {
    let arr = ['','ENE','FEB','MAR','ABR','MAY','JUN','JUL','AGO','SET','OCT','NOV','DIC']
    return arr[vIdMes]
}
export const fuColor12 = vIdMes => {
    let arr = ['#3F51B5','#2196F3','#673AB7','#00BCD4','#009688','#F44336','#9C27B0','#4CAF50','#8BC34A','#FF9800','#795548','#607D8B','#FF5722']
    return arr[vIdMes]
}
export const fuColor12Fecha = vFecha => {
    return fuColor12(parseInt(moment(vFecha).format("MM")));
}   
export const fuServicioInicialColor = vInicial => {
    switch (vInicial) {
        case 'ADETHO': return '#460470'; break;
        case 'ANBF': return '#694A91'; break;
        case 'ANI': return '#0097B0'; break;
        case 'CON': return '#D64164'; break;
        case 'DSI': return '#207FC2'; break;
        case 'EADETHO': return '#460470'; break;
        case 'GAS': return '#E9942C'; break;
        case 'GASTRO': return '#E9942C'; break;
        case 'GOT': return '#7DC54E'; break;
        case 'INF': return '#207FC2'; break;
        case 'MAK': return '#48BDD1'; break;
        default: return '#207FC2';
    }
}
export const fuTurno = vTurno => {
    switch (vTurno) {
        case 'M': return 'Mañana'; break;
        case 'T': return 'Tarde'; break;
        case 'N': return 'Noche'; break;
        default: return vTurno;
    }
}
export const fuTurnoIcono = vTurno => {
    switch (vTurno) {
        case 'M': return 'sunny'; break;
        case 'T': return 'brightness_4'; break;
        case 'N': return 'dark_mode'; break;
        default: return 'sunny';
    }
}
export const fuCopy = vCopy => {
    navigator.clipboard.writeText(vCopy);
}
